import { render, staticRenderFns } from "./PccImport.vue?vue&type=template&id=004a3915&scoped=true&"
import script from "./PccImport.vue?vue&type=script&lang=ts&"
export * from "./PccImport.vue?vue&type=script&lang=ts&"
import style0 from "./PccImport.vue?vue&type=style&index=0&id=004a3915&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004a3915",
  null
  
)

export default component.exports